export default __webpack_public_path__ + "static/media/arrow.19918a16.svg";